// packages/api-client/queries/staffMembers/index.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createStaffMembersQueries = (requests, queryClient) => ({
    useListStaffMembers: (params, options = {}) => useQuery({
        queryKey: ["staff-members", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listStaffMembers(params);
        },
        ...options,
    }),
    useCreateStaffMember: (options = {}) => useMutation({
        ...options,
        mutationFn: (staffMemberAttrs) => {
            return requests.createStaffMember(staffMemberAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["staff-members"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useUpdateStaffMember: (options = {}) => useMutation({
        ...options,
        mutationFn: (staffMemberAttrs) => {
            return requests.updateStaffMember(staffMemberAttrs);
        },
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["staff-members"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map